// Imports
import styled, { css } from 'styled-components/macro';
import { Link } from 'react-router-dom';


// Styled component
export const baseLinkStyle = css`
	color: inherit;
	text-decoration: underline;
	cursor: pointer;
	
	&:hover,
	&:focus {
		text-decoration: none;
	}
`;

export const StyledAnchor = styled.a`
	${baseLinkStyle}
`;

export const StyledLink = styled(Link)`
	${baseLinkStyle}
`;
